import { autoinject } from 'aurelia-framework';
import { DialogController } from "aurelia-dialog";
import { WebApiService } from '../../../services/web-api-service';
import { CarrierRequirementDialogParams } from './carrier-requirement-dialog-params';
import { BusyService } from '../../../services/busy-service';

@autoinject
export class CarrierRequirementDialog {
    public context: CarrierRequirementDialogParams;
    public dialogTitle: string;
    public documentTypes = [];
    public selectedDocumentTypeIds = [];
    public requirementName: string;
    public description: string;

    constructor(
        protected controller: DialogController,
        private api: WebApiService,
        private busyService: BusyService) {
    }

    async activate(params) {
        this.context = params as CarrierRequirementDialogParams;
        if (this.context.carrierMasterApprovalRequirementId) {
            this.dialogTitle = "Edit onboarding requirement";
        } else {
            this.dialogTitle = "Add new onboarding requirement";
        }

        await this.loadDocumentTypes();
    }

    async loadDocumentTypes() {
        this.busyService.on();
        return this.api.get("Carriers", "GetDocumentTypes")
            .then((result) => {
                let allDocumentTypes = JSON.parse(result.response);

                this.documentTypes = allDocumentTypes;
                this.selectedDocumentTypeIds = (this.documentTypes.map(o=>o.documentTypeId));
            })
            .finally(() => this.busyService.off());
    }

    public async save() {
        var model = {
            carrierMasterApprovalRequirementId: this.context.carrierMasterApprovalRequirementId,
            carrierId: this.context.carrierId,
            documentTypeIds: this.selectedDocumentTypeIds.toString(),
            name: this.requirementName,
            description: this.description
        };
        await this.api.post("Carriers", "AddCarrierMasterApprovalRequirement", model);
        this.controller.ok(true);
    }
}